import statusCodeToStepKey from '@/containers/SubscriptionFormPageNew/Components/StatusSteps/statusCodeToStepKey'
import { STEP_NET } from '@/containers/SubscriptionFormPageNew/Components/StatusSteps/stepKeys'

export const normalizeText = value => (value === '' ? '-' : String(value ?? '-'))

export const getStatusVariantByCode = statusCode => {
  const code = String(statusCode || '')
  const step = statusCodeToStepKey[code]
  if (code === 'S0100ERR') return 'warning'
  if (step === STEP_NET) return 'success'
  if (code === 'TRERR' || code === 'R0400' || code === 'R0500') return 'danger'
  if (code === 'Z0100') return 'accent'
  if (code === 'W0100') return 'warning'
  if (code === 'C020') return 'warning'
  if (code === 'C050') return 'accent'
  if (code === 'C0100') return 'accent'

  return 'neutral'
}

export const shouldDisableSignNet = statusCode => String(statusCode || '') === 'S0100'
